export function getBorder(noBorder: boolean, isActive: boolean) {
  if (isActive) {
    return '1px solid #163567';
  }
  if (noBorder) {
    return '1px solid transparent';
  }
  return '1px solid #596F93';
}
